<template>
  <v-container
    ref="sectionRoot"
    class="coverage-section py-8 py-md-12"
    :class="{ 'is-visible': visible }"
  >
    <v-row class="text-center mb-6 mb-md-12 fade-slide-down">
      <v-col cols="12" md="10" lg="8" class="mx-auto">
        <div class="section-badge mb-3">
          <span class="section-badge__dot"></span>
          Coberturas
        </div>

        <h2 class="header-title mb-3">
          Las coberturas perfectas para ti y tu familia
        </h2>

        <p class="header-subtitle mb-0">
          Consulta externa, urgencias médicas, dental y visual.
          <br class="d-none d-md-block" />
          Protección real para lo que sí importa.
        </p>
      </v-col>
    </v-row>

    <v-row class="justify-center" dense>
      <v-col
        v-for="(item, i) in coberturas"
        :key="`cobertura-${i}`"
        cols="12"
        sm="6"
        md="3"
        class="px-2 py-2"
        :style="{ animationDelay: `${i * 0.12}s` }"
      >
        <v-card
          class="coverage-card text-center d-flex flex-column align-center"
          flat
          @mouseenter="hoverIndex = i"
          @mouseleave="hoverIndex = null"
          :class="{ 'coverage-card--active': hoverIndex === i }"
        >
          <span class="coverage-card__accent"></span>

          <div class="icon-wrapper mb-5" :class="{ 'icon-wrapper--active': hoverIndex === i }">
            <v-icon
              size="30"
              class="coverage-icon"
              :class="{ 'coverage-icon--active': hoverIndex === i }"
            >
              {{ item.icon }}
            </v-icon>
          </div>

          <h3 class="coverage-title mb-2">
            {{ item.titulo }}
          </h3>

          <p class="coverage-description mb-0">
            {{ item.descripcion }}
          </p>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "SeccionCobComponent",
  data() {
    return {
      hoverIndex: null,
      visible: false,
      coberturas: [
        {
          icon: "mdi-stethoscope",
          titulo: "Consulta Médica",
          descripcion: "Atención con médicos especialistas certificados."
        },
        {
          icon: "mdi-hospital",
          titulo: "Urgencias Médicas",
          descripcion: "Cobertura para emergencias por enfermedad o accidente."
        },
        {
          icon: "mdi-tooth-outline",
          titulo: "Atención Dental",
          descripcion: "Servicios dentales con especialistas en ortodoncia y más."
        },
        {
          icon: "mdi-glasses",
          titulo: "Salud Visual",
          descripcion: "Exámenes de la vista y lentes a precios preferentes."
        }
      ]
    };
  },
  mounted() {
    const el = this.$refs.sectionRoot?.$el || this.$refs.sectionRoot;
    if (!el || typeof IntersectionObserver === "undefined") {
      this.visible = true;
      return;
    }

    this._observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          this.visible = true;
          this._observer.disconnect();
        }
      },
      { threshold: 0.15 }
    );
    this._observer.observe(el);
  },
  beforeDestroy() {
    this._observer?.disconnect();
  }
};
</script>

<style scoped>
.coverage-section {
  background: linear-gradient(180deg, #ffffff 0%, #f5f9fd 100%);
  border-radius: 24px;
}

/* Badge con punto indicador, más propio de UI actual */
.section-badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 7px 16px 7px 12px;
  border-radius: 999px;
  background: #dceeff;
  color: #1b4f8c;
  font-size: 0.82rem;
  font-weight: 700;
  letter-spacing: 0.4px;
}

.section-badge__dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #1b4f8c;
}

.header-title {
  font-weight: 800;
  letter-spacing: -0.02em;
  color: #16233a;
}

.header-subtitle {
  color: #64748b;
}

.fade-slide-down {
  opacity: 0;
  transform: translateY(-24px);
}

.is-visible .fade-slide-down {
  animation: fadeSlideDown 0.8s ease forwards;
}

@keyframes fadeSlideDown {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Card: sin borde, sombra suave, radio más grande = look más actual */
.coverage-card {
  position: relative;
  height: 100%;
  min-height: 232px;
  padding: 32px 22px;
  border-radius: 28px;
  background: #ffffff;
  box-shadow: 0 2px 10px rgba(15, 23, 42, 0.05);
  overflow: hidden;
  opacity: 0;
  transform: translateY(24px);
  transition:
    transform 0.32s cubic-bezier(0.22, 1, 0.36, 1),
    box-shadow 0.32s ease;
}

.is-visible .coverage-card {
  animation: fadeInUp 0.55s ease forwards;
}

/* Barra de acento que "entra" desde arriba al hacer hover */
.coverage-card__accent {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #1b4f8c, #4f8fd6);
  transform: scaleX(0);
  transform-origin: left;
  transition: transform 0.32s ease;
}

.coverage-card:hover .coverage-card__accent,
.coverage-card--active .coverage-card__accent {
  transform: scaleX(1);
}

.coverage-card:hover,
.coverage-card--active {
  transform: translateY(-10px);
  box-shadow: 0 20px 40px rgba(27, 79, 140, 0.16);
}

/* Ícono circular con inversión de color al hover: patrón muy actual */
.icon-wrapper {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #dceeff;
  transition: background-color 0.32s ease, transform 0.32s ease;
}

.icon-wrapper--active,
.coverage-card:hover .icon-wrapper {
  transform: scale(1.06);
  background: linear-gradient(135deg, #1b4f8c, #2d6bb0);
}

.coverage-icon {
  color: #1b4f8c !important;
  transition: color 0.32s ease;
}

.coverage-icon--active,
.coverage-card:hover .coverage-icon {
  color: #ffffff !important;
}

.coverage-title {
  font-size: 1.08rem;
  font-weight: 700;
  color: #16233a;
  line-height: 1.35;
}

.coverage-description {
  font-size: 0.93rem;
  line-height: 1.6;
  color: #6b7280;
}

@keyframes fadeInUp {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (prefers-reduced-motion: reduce) {
  .fade-slide-down,
  .coverage-card {
    opacity: 1;
    transform: none;
    animation: none;
  }

  .coverage-card:hover,
  .coverage-card--active {
    transform: none;
  }
}

@media (max-width: 600px) {
  .coverage-section {
    border-radius: 18px;
  }

  .coverage-card {
    min-height: auto;
    padding: 26px 20px;
  }

  .header-subtitle br {
    display: none;
  }
}
</style>